import get from 'lodash/get';
import {AppDispatch} from "../global.state";
import {actions} from "./app";
import {briefcase, calendar, fileTrayStacked, medkit} from "ionicons/icons";
import {AppCollection} from "../models/Principal";
import firebase from "firebase/compat";
import {DateTime} from "luxon";
import sanitizeHtml from 'sanitize-html';

export const sanitizeConfig = {
  // default para textAreas
  noHtml: {
    allowedTags: ['br'],
    allowedAttributes: {},
  },

  // apenas formatação de texto, sem blocos
  onlyText: {
    allowedTags: ['b', 'i', 'em', 'strong', 'u', 'br', 'p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    allowedAttributes: {
      'span': ['style'],
    },
  },

  extended: {
    allowedTags: ['b', 'i', 'em', 'strong', 'u', 'br', 'p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'li', 'ol', 'a'],
    allowedAttributes: {
      'a': ['href', 'target'],
    },
  },

  cms: {
    allowedTags: ['b', 'i', 'em', 'strong', 'u', 'br', 'p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'li', 'div', 'img', 'iframe', 'a'],
    allowedAttributes: {
      'span': ['style'],
      '*': ['class'],
      'img': ['src'],
      'iframe': ['*'],
      'a': ['class', 'href', 'target'],
    },
  }
};

export function safeInnerHtmlText(texto:string, options?:{}, line2br: boolean = true) {
  if (!texto) {
    return {
      __html: '',
    };
  }

  let textoOk = texto;
  if (line2br)
    textoOk = texto.replace(/\n/g, '<br/>');

  return {
    __html: sanitizeText(textoOk, options),
  };
}

/*
Limpar inputs de texto e substituir quebras por <br/>
 */
export function sanitizeText(dirty:string, options?:{}) {
  if (!dirty)
    return '';

  const config = options || sanitizeConfig.noHtml;

  return sanitizeHtml(dirty, config);
}

export function swicthed(previous:any, actual:any, attr:string) {
  const previousValue:any = get(previous, attr, undefined);
  const value:any = get(actual, attr, undefined);

  if ((value && !previousValue) || previousValue !== value)
    return true;

  return false;
}

export function swicthedTo(previous:any, actual:any, attr:string, value:any) {
  const previousValue:any = get(previous, attr, undefined);
  const actualValue:any = get(actual, attr, undefined);

  if ((actualValue && !previousValue && actualValue === value) || (previousValue !== actualValue && actualValue === value))
    return true;

  return false;
}

export function formatNumber(num:number | string | null | undefined, decimalPlaces:number=2):string {
  if (num === undefined || num === null || !num)
    return "";

  if (typeof num === 'string')
    num = Number(num);

  return num.toFixed(decimalPlaces).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

export function string2Number(str: string | null | undefined) {
  if (str === undefined || str === '' || str === null)
    return undefined;

  let stringOk = str.replace(/\./g, '');
  stringOk = stringOk.replace(/,/g, '.');

  return Number(stringOk);
}

export function goBack(global:any, setGlobal:any, props:any): void {
  if (props.returnTo) {
    props.history.push(props.returnTo);
  } else {
    const jumpHistory = global.jumpHistory;
    const lastJump = jumpHistory.pop();
    setGlobal({jumpHistory}, () => {
      props.history.push(lastJump);
    });
  }
}

export function goBackNG(jumpHistory:string[], dispatch:AppDispatch, props:any): void {
  if (props.returnTo) {
    props.history.push(props.returnTo);
  } else {
    const newHistory = [...jumpHistory];
    const lastJump = newHistory.pop();
    dispatch(actions.setJumpHistory(newHistory));
    props.history.push(lastJump);
  }
}

export function filtrarColecao(colecao: any[], criterio: string, campo: string): any[] {
  if (!criterio) {
    return colecao;
  } else {
    const criterioLower = criterio.toLowerCase();
    return colecao.filter((i: any) => (
      i[campo].toLowerCase().indexOf(criterioLower) >= 0
    ));
  }
}

export interface FazendaFiltros {
  estado: string;
  cidade: string;
  apenasFavoritas: boolean;
  tipos: string[];
}

export const filtrosFazendaVazios: FazendaFiltros = {
  estado: '',
  cidade: '',
  apenasFavoritas: false,
  tipos: [],
};

export function filtrarFazendas(colecao: any[], criterio: string, filtros: FazendaFiltros): any[] {
  let resultado = filtrarColecao(colecao, criterio, 'nome');

  if (filtros.estado)
    resultado = resultado.filter((f: any) => f.estado === filtros.estado);

  if (filtros.cidade)
    resultado = resultado.filter((f: any) => f.cidade === filtros.cidade);

  if (filtros.apenasFavoritas)
    resultado = resultado.filter((f: any) => f.matriz);

  if (filtros.tipos.length > 0)
    resultado = resultado.filter((f: any) => Array.isArray(f.tipo) && f.tipo.some((t: string) => filtros.tipos.includes(t)));

  return resultado;
}

export function ordenarFavoritasPrimeiro(colecao: any[]): any[] {
  return [...colecao].sort((a: any, b: any) => {
    if (!!a.matriz !== !!b.matriz)
      return a.matriz ? -1 : 1;
    return (a.nome || '').localeCompare(b.nome || '');
  });
}

export function temFiltrosAtivos(filtros: FazendaFiltros): boolean {
  return !!filtros.estado || !!filtros.cidade || filtros.apenasFavoritas || filtros.tipos.length > 0;
}

export function opcoesEstadoECidade(colecao: any[], estadoSelecionado: string): {estados: string[], cidades: string[]} {
  const estados = Array.from(new Set(colecao.map((f: any) => f.estado).filter(Boolean))).sort() as string[];
  const cidadesFonte = estadoSelecionado ? colecao.filter((f: any) => f.estado === estadoSelecionado) : colecao;
  const cidades = Array.from(new Set(cidadesFonte.map((f: any) => f.cidade).filter(Boolean))).sort() as string[];
  return {estados, cidades};
}

export async function base64FromPath(path: string): Promise<string> {
  const response = await fetch(path);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject('method did not return a string');
      }
    };
    reader.readAsDataURL(blob);
  });
}

export function pluralize(term: string, count: number, suffixSingular: string = '', suffixPlural: string = 's'): string {
  if (count === 1)
    return `${term}${suffixSingular}`;
  return `${term}${suffixPlural}`;
}

export const getColectionIcon = (type: string) => {
  switch (type) {
    case "fazendas":
      return fileTrayStacked;
    case "veterinarios":
      return medkit;
    case "lojas":
      return briefcase;
    case "eventos":
      return calendar;
  }
};

export const getCollectionFromPath = (path: string): AppCollection => {
  return path.split('/')[0];
}

export const getCollectionFromRef = (ref: firebase.firestore.DocumentReference): AppCollection => {
  return ref.parent.id;
}

export const dataInCurrentMonth = (data: Date): boolean => {
  const limite = DateTime.now();
  const criadoEm = DateTime.fromJSDate(data);
  return criadoEm.year === limite.year && criadoEm.month === limite.month;
}

export function validateEmail(email: string) {
  if (!email)
    return false;

  return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
}
